import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import {
  ModalRoot,
  ModalContainer,
  ModalPaper,
} from "../styles/sharedComponentStyles";

export default function ServerModal(content) {
  const rootRef = React.useRef(null);
  const [var3, setVar3] = useState(content.content);
  return (
    <ModalRoot ref={rootRef}>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open
        aria-labelledby="server-modal-title"
        aria-describedby="server-modal-description"
        container={() => rootRef.current}
      >
        <ModalContainer>
          <ModalPaper>
            <h2 id="server-modal-title">Something Went Wrong,</h2>
            <p id="server-modal-description">{var3}</p>
          </ModalPaper>
        </ModalContainer>
      </Modal>
    </ModalRoot>
  );
}
